"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var ProductsGrid = /*#__PURE__*/function (_window$AbstractView) {
    _inherits(ProductsGrid, _window$AbstractView);

    var _super = _createSuper(ProductsGrid);

    _createClass(ProductsGrid, null, [{
      key: "QUICK_VIEW_WRAPPER",
      get: function get() {
        return '<div class="products-grid__quick-product-wrapper"></div>';
      }
      /*
       *    Events
       */

    }, {
      key: "QUICK_VIEW_SCROLL_TOP",
      get: function get() {
        return 'quick-view-scroll-top';
      }
      /*
       *    Methods
       */

    }]);

    function ProductsGrid(id, options) {
      var _this;

      _classCallCheck(this, ProductsGrid);

      var OPTIONS_MANDATORY = {
        watchResize: options.quickViewModeEnabled,
        watchResizeTimeout: 300
      };
      options = $.extend(true, _.clone(options), OPTIONS_MANDATORY);
      _this = _super.call(this, id, options);
      _this.$quickProductWrapper = null;
      _this.$quickProductCloseBtn = null;
      return _this;
    }

    _createClass(ProductsGrid, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        this.$productCards = this.$domElement.find(".card.product-card");
        this.$domElement.on(AbstractView.EL_AUTO_INSTANCE_MUTATION, function (event, type, el) {
          if (type == "removed") {
            _this2.$domElement.find(".products-grid-col").filter(function (i, el) {
              return $(el).children().length == 0;
            }).remove();
          }
        });
        this.$domElement.find(".products-grid-col").each(function (i, el) {
          _get(_getPrototypeOf(ProductsGrid.prototype), "addModules", _this2).call(_this2, [new window.ProductCard(null, {
            $domElement: $(el).find(".card.product-card"),
            onProductCardClick: _this2.productCard_onClick.bind(_this2),
            animatedPageEnter: false
          })]);
        });

        _get(_getPrototypeOf(ProductsGrid.prototype), "init", this).call(this);
        /**
         *  Observer for new modules add / old modules remove
         */


        this.setAutoInstance([{
          selector: ".card.product-card",
          ModuleClass: window.ProductCard,
          observeChild: "#bc-sf-filter-products",
          // if null it takes the domElement of the view
          subtree: true,
          options: {
            onProductCardClick: this.productCard_onClick.bind(this),
            animatedPageEnter: false
          }
        }]);
      }
    }, {
      key: "onReady",
      value: function onReady() {
        // console.log('ON_DOCUMENT_READYON_DOCUMENT_READYON_DOCUMENT_READY');
        // console.log('this.$domElement', this.$domElement);
        // console.log('this.$domElement', this.$domElement[0].id);
        // console.log('CHECK', this.$domElement.find(".product-card").length);
        if (false) {
          // console.log('homepage__featured-products-grid');
          var products = [];
          this.$domElement.find(".product-card").each(function (i, el) {
            // console.log('TTTTT', i, el, $(el).attr('data-product-id'));
            var temp_pr = {
              item_id: $(el).attr('data-product-id').toString(),
              item_name: $(el).find('.product-name').text(),
              currency: Shopify.currency.active,
              index: i + 1,
              item_brand: $(el).find('.product-brand').text(),
              item_category: "Apparel",
              item_list_id: 'featured_products',
              item_list_name: 'Featured products',
              price: $(el).find('.product-price__final').length > 0 ? Number($(el).find('.product-price__final').text().toString().replace(/(\r\n|\n|\r)/gm, "").replace('€', '').replace('.', '').replace(',', '.')) : undefined,
              quantity: 1
            };
            products.push(temp_pr);
          });
          /* console.log('dataLayerPush', {
              event: "view_item_list",
              ecommerce: {
                  items: products
              }
          }); */

          dataLayer.push({
            ecommerce: null
          });
          dataLayer.push({
            event: "view_item_list",
            ecommerce: {
              items: products
            }
          });
        }

        _get(_getPrototypeOf(ProductsGrid.prototype), "onReady", this).call(this);
      }
    }, {
      key: "toggleFilterMode",
      value: function toggleFilterMode($toggleBtn) {
        this.$domElement.toggleClass("filters-closed");
        $toggleBtn.trigger("change-state", [this.$domElement.hasClass("filters-closed") ? true : false]);
      }
    }, {
      key: "productCard_onClick",
      value: function productCard_onClick(event) {
        var _this3 = this;

        var GRID_INDEX = $(event.delegateTarget).closest(".product-card").attr("data-grid-index");
        var INVENTORY_Q = $(event.delegateTarget).closest(".product-card").attr("data-inventory_quantity");
        var P_LIST = jQuery('body').attr('data-coll-name') ? jQuery('body').attr('data-coll-name').toLowerCase().trim() : '';
        var P_LIST_ID = jQuery('body').attr('data-coll-id') ? jQuery('body').attr('data-coll-id').toLowerCase().trim() : '';

        if (window.Globals.IS_QUICK_PRODUCT_AUTHORIZED_DEVICE_TYPE) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          this.disposeQuickProduct();
          this.$targetCard = $(event.delegateTarget).closest(".card.product-card");
          this.$targetCard.addClass("quick-product");
          var PRODUCT_HANDLE = $(event.delegateTarget).closest(".product-card").attr("data-product-handle");
          this.attachQuickProduct($(event.delegateTarget).closest(".products-grid-col").index());

          this._killAJAXRequest();

          this.AJAXrequest = $.ajax({
            dataType: "json",
            url: "/products/" + PRODUCT_HANDLE + ".js",
            success: function success(details) {
              console.log('RETRIVE PRODUCT [' + details.title + ']', details);
              details.has_related_post = false;
              details.product_quantity = INVENTORY_Q;

              for (var i = 0, len = details.tags.length; i < len; i++) {
                if (details.tags[i] == "has_post") {
                  details.has_related_post = true;
                  break;
                }
              }

              $.extend(true, details, {
                only_one_left_variants: _this3.$targetCard.data("only-one-left-variants"),
                data_images_alt: _this3.$targetCard.data("images-alt"),
                original_size: _this3.$targetCard.data("original-size"),
                original_metric: _this3.$targetCard.data("original-metric")
              });

              var MARKUP = window._.template($("#product-quick-view-template").html())(details);

              _this3.$quickProductWrapper.html(MARKUP);

              _this3.quickProductContent = new window.ProductContent(_this3.id + "__quick-product-content_" + PRODUCT_HANDLE, {
                $domElement: _this3.$quickProductWrapper.find(".product-content"),
                quickView: _this3.options.quickViewModeEnabled,
                singlePageURL: location.protocol + '//' + location.host + details.url,
                productDefaultImage: details.images[0]
              });
              _this3.$quickProductCloseBtn = _this3.$quickProductWrapper.find(".product-quick-view__service-menu .btn-close");

              _this3.$quickProductCloseBtn.one("click", _this3.closeQuickProduct.bind(_this3));

              _this3.quickProductContent.init();

              window.TweenMax.from(_this3.$quickProductWrapper, 1, {
                force3D: "auto",
                opacity: 0,
                ease: window.Circ.easeOut
              });
              /*
              GA4
              */

              _this3.pushSelectItemDataLayer(details, GRID_INDEX, INVENTORY_Q, P_LIST, P_LIST_ID, false);
            },
            error: function error(msg) {
              console.log("Error retriving data for quick view, href is executed as fallback.");
              Turbolinks.visit($(event.delegateTarget).attr("href"));
            }
          });
        } else {
          /*
          GA4
          */
          // event.preventDefault();
          // event.stopPropagation();
          // event.stopImmediatePropagation();
          // console.log('NEW TEST A', $(event.delegateTarget));
          // console.log('NEW TEST B', $(event.delegateTarget).closest(".product-card").find('.product-price__final'));
          var details = {
            id: $(event.delegateTarget).closest(".product-card").attr("data-product-id"),
            title: $(event.delegateTarget).closest(".product-card").find('.product-name').html(),
            vendor: $(event.delegateTarget).closest(".product-card").find('.product-brand').html(),
            tags: $(event.delegateTarget).closest(".product-card").attr("data-tags").split(','),
            variants: [{
              option2: $(event.delegateTarget).closest(".product-card").find('.card-body').attr("data-gender") !== '' ? $(event.delegateTarget).closest(".product-card").find('.card-body').attr("data-gender") : undefined
            }],
            price: $(event.delegateTarget).closest(".product-card").find('.product-price__final').length > 0 ? $(event.delegateTarget).closest(".product-card").find('.product-price__final').html().replace('€', '').replace('.', '').replace(',', '.') : undefined
          };
          this.pushSelectItemDataLayer(details, GRID_INDEX, INVENTORY_Q, P_LIST, P_LIST_ID, true);
        }
      }
      /*
      GA4
      */

    }, {
      key: "pushSelectItemDataLayer",
      value: function pushSelectItemDataLayer(product_info, grid_index, inventory_q, p_list, p_list_id, is_desktop) {
        console.log('----> pushSelectItemDataLayer');
        console.log('----> is_desktop', is_desktop);
        var products = [];
        var item_category3 = '';
        var item_category4;
        var color = '';
        product_info.tags.forEach(function (tag) {
          //console.log('tag', tag);
          if (tag.indexOf('type') > -1) {
            item_category3 = tag.split('-')[1];
          }

          if (tag.indexOf('long_color') > -1) {
            color = tag.split('-')[1];
          }
        });
        product_info.tags.forEach(function (tag) {
          //console.log('tag', tag);
          //console.log('item_category3', item_category3);
          if (tag.indexOf('subcategory') > -1) {
            //console.log('tag.split', tag.split('-')[1]);
            if (tag.split('-')[1] != item_category3) {
              item_category4 = tag.split('-')[1];
            }
          }
        });
        product_info.tags.forEach(function (tag) {
          //console.log('tag', tag);
          //console.log('item_category3', item_category3);
          if (tag.indexOf('abb2') > -1) {
            //console.log('tag.split', tag.split('-')[1]);
            if (tag.split('-')[1] != item_category3) {
              var second = tag.split('-')[2] ? '-' + tag.split('-')[2] : '';
              item_category4 = tag.split('-')[1] + second;
            }
          }
        });
        var temp_price = '';

        if (is_desktop) {
          temp_price = product_info.price ? product_info.price : undefined;
        } else {
          temp_price = product_info.price ? slate.Currency.formatMoney(product_info.price, Globals.moneyFormat).toString().replace('€', '').replace('.', '').replace(',', '.') : undefined;
        }

        var temp_pr = {
          item_id: product_info.id.toString(),
          item_name: product_info.title,
          currency: Shopify.currency.active,
          index: Number(grid_index),
          item_brand: product_info.vendor,
          item_category: "Apparel",
          item_category2: product_info.variants[0].option2,
          item_category3: item_category3,
          item_category4: item_category4,
          item_list_id: p_list_id,
          item_list_name: 'main',
          price: temp_price ? Number(temp_price) : undefined,
          available_quantity: Number(inventory_q),
          quantity: 1
        };
        products.push(temp_pr);
        /* console.log('dataLayerPush', {
        event: "select_item",
        ecommerce: {
            items: products
        }
        }); */

        dataLayer.push({
          ecommerce: null
        });
        dataLayer.push({
          event: "select_item",
          ecommerce: {
            items: products
          }
        });
      }
    }, {
      key: "closeQuickProduct",
      value: function closeQuickProduct(event) {
        var _this4 = this;

        event.stopPropagation();
        event.stopImmediatePropagation();
        $(window).off(Globals.BODY_SCROLL_ENABLED_CHANGE + "." + this.id);

        this._disposeWatchers();

        if (this.quickProductContent) {
          var tl = new window.TimelineMax({
            onComplete: function onComplete() {
              _this4.options.showFilterNavbarCallback();

              _this4.disposeQuickProduct();
            }
          });
          tl.fromTo(this.$quickProductWrapper, 0.35, {
            minHeight: 0,
            pointerEvents: "none",
            overflow: "hidden"
          }, {
            force3D: "auto",
            autoAlpha: 0,
            ease: window.Expo.easeInOut
          });
          tl.to(this.$quickProductWrapper, 0.8, {
            onStart: function onStart() {
              _this4.$quickProductWrapper.height(_this4.$quickProductWrapper.outerHeight());

              _this4.$quickProductWrapper.find("> *").css("position", "absolute");
            },
            force3D: "auto",
            minHeight: 0,
            height: 0,
            ease: window.Expo.easeInOut
          });
        }
      }
    }, {
      key: "disposeQuickProduct",
      value: function disposeQuickProduct() {
        $(window).off(Globals.BODY_SCROLL_ENABLED_CHANGE + "." + this.id);

        this._disposeWatchers();

        if (this.$targetCard) {
          this.$targetCard = null;
        }

        if (this.quickProductContent) {
          this.$quickProductCloseBtn.off();
          this.$quickProductCloseBtn = null;
          this.quickProductContent.dispose();
          this.quickProductContent = null;
          this.$quickProductWrapper.off();
          this.$quickProductWrapper.remove();
          this.$quickProductWrapper = null;
          this.$productCards.removeClass("quick-product"); // Since quickProductContent add the buy overlay in the body we need to explicitely remove it

          $(".buy-overlay").remove();
        }
      }
    }, {
      key: "attachQuickProduct",
      value: function attachQuickProduct(TARGET_COL_INDEX) {
        var _this5 = this;

        this.targetColIndex = TARGET_COL_INDEX;
        $(ProductsGrid.QUICK_VIEW_WRAPPER).insertAfter(this._getAnchor());
        this.$quickProductWrapper = $(".products-grid__quick-product-wrapper");

        this._disposeWatchers();

        this.wrapperScrollWatcher = new window.ScrollWatcher();

        if (window.Globals.IS_QUICK_PRODUCT_AUTHORIZED_DEVICE_TYPE) {
          $(window).off(Globals.BODY_SCROLL_ENABLED_CHANGE + "." + this.id).on(Globals.BODY_SCROLL_ENABLED_CHANGE + "." + this.id, function (event, enabled) {
            if (enabled) {
              if (!_this5.wrapperScrollWatcher.viewportState.isInViewport) {
                _this5.options.showFilterNavbarCallback();
              }
            }
          });
        } // ---------------------------------


        this.gridScrollWatcher = new window.ScrollWatcher();
        $(this.$domElement.find(".card.product-card")[0]).on(ScrollWatcher.IS_IN_VIEWPORT, function (event, watcher) {
          event.stopPropagation();
          event.stopImmediatePropagation();

          _this5.options.showFilterNavbarCallback();
        });
        $(this.$domElement.find(".card.product-card")[0]).on(ScrollWatcher.HAS_FULLY_EXIT_VIEWPORT, function (event, watcher) {
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (_this5.wrapperScrollWatcher.viewportState.isInViewport) {
            _this5.options.hideFilterNavbarCallback();
          }
        });
        this.gridScrollWatcher.init(this.$domElement.find(".card.product-card")[0], {
          rootMargin: -window.siteHeader.currentHeight + "px 0px 0px 0px"
        }); // ---------------------------------

        this.$quickProductWrapper.on(ScrollWatcher.IS_IN_VIEWPORT, function (event) {
          event.stopPropagation();
          event.stopImmediatePropagation();

          _this5.options.hideFilterNavbarCallback();
        });
        this.$quickProductWrapper.on(ScrollWatcher.HAS_FULLY_EXIT_VIEWPORT, function (event) {
          event.stopPropagation();
          event.stopImmediatePropagation();

          _this5.options.showFilterNavbarCallback();
        });
        this.wrapperScrollWatcher.init(this.$quickProductWrapper, {
          rootMargin: "0px 0px 0px 0px"
        });
        window.TweenMax.to(window, 0.55, {
          scrollTo: {
            autoKill: false,
            y: this.$quickProductWrapper[0]
          },
          onStart: function onStart() {
            _this5.$domElement.trigger(ProductsGrid.QUICK_VIEW_SCROLL_TOP, "start");
          },
          onComplete: function onComplete() {
            _this5.$domElement.trigger(ProductsGrid.QUICK_VIEW_SCROLL_TOP, "end");
          },
          ease: window.Circ.easeOut
        });
      }
    }, {
      key: "resizeHandler",
      value: function resizeHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      }
    }, {
      key: "resizeTimeoutHandler",
      value: function resizeTimeoutHandler() {
        if (window.Globals.IS_QUICK_PRODUCT_AUTHORIZED_DEVICE_TYPE) {
          if (this.$targetCard) {
            this.disposeQuickProduct();
            /*this.targetColIndex = this.$targetCard.closest(".products-grid-col").index();
            if (this.$quickProductWrapper) {
                this.$quickProductWrapper.remove();
                this.$quickProductWrapper.insertAfter(
                    this._getAnchor()
                );
            }*/
          }
        }
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this._killAJAXRequest();

        $(".products-grid__quick-product-wrapper").off();
        $(window).off(Globals.BODY_SCROLL_ENABLED_CHANGE + "." + this.id);

        if (this.$quickProductWrapper) {
          TweenMax.killTweensOf(this.$quickProductWrapper);
        }

        this._disposeWatchers();

        this.disposeQuickProduct();
        this.$productCards = null;

        _get(_getPrototypeOf(ProductsGrid.prototype), "dispose", this).call(this);
      }
    }, {
      key: "_getAnchor",
      value: function _getAnchor() {
        var gap;

        if (window.Breakpoints.matches(window.Breakpoints.MIN_WIDTH, window.Breakpoints.LG)) {
          gap = (this.targetColIndex + 1) % 3;
          gap = gap > 0 ? 3 - gap : 0;
        } else {
          gap = (this.targetColIndex + 1) % 2;
          gap = gap > 0 ? 2 - gap : 0;
        }

        var $cols = this.$domElement.find(".products-grid-col");

        if ($cols[this.targetColIndex + gap]) {
          return $cols[this.targetColIndex + gap];
        } else {
          return $cols[this.targetColIndex];
        } //return this.$domElement.find(".products-grid-col:nth-child(" + ((this.targetColIndex + 1) + gap) + ")");

      }
    }, {
      key: "_killAJAXRequest",
      value: function _killAJAXRequest() {
        if (this.AJAXrequest) {
          this.AJAXrequest.abort();
          this.AJAXrequest = null;
        }
      }
    }, {
      key: "_disposeWatchers",
      value: function _disposeWatchers() {
        $(this.$domElement.find(".card.product-card")[0]).off(ScrollWatcher.IS_IN_VIEWPORT);
        $(this.$domElement.find(".card.product-card")[0]).off(ScrollWatcher.HAS_FULLY_EXIT_VIEWPORT);

        if (this.$quickProductWrapper) {
          this.$quickProductWrapper.off(ScrollWatcher.IS_IN_VIEWPORT);
          this.$quickProductWrapper.off(ScrollWatcher.HAS_FULLY_EXIT_VIEWPORT);
        }

        if (this.wrapperScrollWatcher) {
          this.wrapperScrollWatcher.dispose();
          this.wrapperScrollWatcher = null;
        }

        if (this.gridScrollWatcher) {
          this.gridScrollWatcher.dispose();
          this.gridScrollWatcher = null;
        }
      }
    }]);

    return ProductsGrid;
  }(window.AbstractView);

  window.ProductsGrid = ProductsGrid;
})(window);
